/**
 * Copyright (c) 2022, ResMed Inc. All rights reserved.
 */


/**
 * SQSService
 *
 * Service for Werewolf API SQS calls
 */
export default class SQSService {
    _AWSClient;
    _HttpService;

    baseUrl = `${process.env.REACT_APP_WEREWOLF_API_INVOKE_URL}/v1/sqs`

    constructor(httpService) {
        this._AWSClient = require('aws-sdk');
        this._HttpService = httpService
    }

    /**
     * Sends a message to Queue
     *
     * @param message message to send
     * @param alert   alert function to call
     * @param refresh refresh function to call on success
     * @throws error on failed put
     */
    sendMessage(message, alert, refresh) {
        let url = `${this.baseUrl}/send`

        this._HttpService.asyncPost(url, JSON.stringify(message), "Send message", alert, refresh)
    }
}